import React, { useState } from "react";
import DataTable from '../../components/DataTable'
import { activitiesTableConfig, installationsTableConfig } from "../../datatable.config";
import { Box, Chip, CircularProgress, Hidden, Stack, TablePagination, Typography, useTheme } from "@mui/material";
import CardComponent from "../../components/Card";
import { useTranslation } from "react-i18next";
import { formatDateToDDMMYYYYHHSSFrEpoch, mappingValue } from "../../utils/util";
import { ItemIcon } from "../../components/IconComponent";

export default function InstallationCompletedView(props) {
    const { t } = useTranslation();
    const { installations, onShowDetail, paging } = props
    const [rowsPerPage, setRowsPerPage] = useState(paging && paging.size ? paging.size : 10);

    const handleChangePage = (event, newPage) => {
        props.handleChangePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        let _size = paging.size ? paging.size : 10;
        console.log("AAA parseInt(value, _size): ", parseInt(value, _size))
        setRowsPerPage(value);
        props.handleChangeRowsPerPage(value);
    };

    return (
        <CardComponent noBorder marginTop={5}
            header={{
                title: t('waiting_add_device'),
            }}>
            {props.showLoadingInstallation ? <Stack flex={1} alignItems={'center'}><CircularProgress /></Stack> :
                <>
                    <Hidden mdDown>
                        <DataTable variant='ordersTable'
                            data={installations} tableConfig={installationsTableConfig} onShowDetail={onShowDetail}
                        ></DataTable>
                    </Hidden>
                    <Hidden mdUp>
                        {installations.length == 0 ? <Typography variant='subtitle2' marginX={1} marginY={1}>No Record Found.</Typography> : 
                        installations.map((item, index) => {
                            return (
                                <Box key={index} mb={1} onClick={() => props.onShowDetail(item)}>
                                    <InstallationItem item={item} />
                                </Box>
                            )
                        })}
                    </Hidden>
                    {paging.total > 0 && <TablePagination
                        component="div"
                        count={paging.total}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        page={paging.page ? paging.page - 1 : 0}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />}
                </>}
        </CardComponent>
    )
}

function InstallationItem(props) {
    const { item } = props;
    const { palette } = useTheme();
    const { t } = useTranslation();

    let statusColor = palette.info;
    if (item.state == 'NEW') statusColor = palette.info;
    else if (item.state == 'CANCELLED') statusColor = palette.error;
    else if (item.state == 'COMPLETED') statusColor = palette.success;
    else if (item.state == 'IN_PROGRESS') statusColor = palette.warning;

    let stageColor = palette.custom3;

    return (
        <CardComponent paddingY={1} paddingX={2}>
            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                <Stack flex={1} direction={'row'} alignItems='center' spacing={1}>
                    <Typography variant='body1'>{item.number}</Typography>
                    <Chip sx={{ background: statusColor.light, color: statusColor.main }} variant='customOutlined' size='small' label={t(mappingValue(item.state))} />
                </Stack>
                {item.stage && <Chip sx={{ background: stageColor.light, color: stageColor.main }} variant='customOutlined' size='small' label={t(mappingValue(item.stage.name))} />}
            </Stack>
            <Stack direction={'row'} alignItems='center' spacing={1} mt={1}>
                <Stack flex={1}>
                    <Typography variant='body2'>{item.contact && item.contact.name ? item.contact.name : null}</Typography>
                    {item.key_dates && <Typography variant='subtitle2'>{formatDateToDDMMYYYYHHSSFrEpoch(item.key_dates.submitted_on)}</Typography>}
                </Stack>
            </Stack>
        </CardComponent>
    )
}